import React from 'react';

import { SVGProps } from '@/components/svg/SVGProps';

const TrcukOneIcon = ({ fill = '#124734', width = '42', height = '34' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 42 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.96 14.0273L35.81 5.9573C35.53 5.5173 35.04 5.2473 34.51 5.2473H27.16V2.2773C27.16 1.1573 26.25 0.237305 25.12 0.237305H2.04C0.92 0.237305 0 1.1473 0 2.2773V20.4773H41.2V14.8573C41.2 14.5673 41.12 14.2773 40.96 14.0273ZM14.3 16.6773H13.11V6.75731L10.94 8.0273V6.7473L13.11 5.4873H14.3V16.6773ZM29.4 14.9473V8.6473H32.28C32.69 8.6473 33.07 8.8573 33.3 9.1973L37.07 14.9473H29.41H29.4Z"
        fill={fill}
      />
      <path
        d="M11.8402 33.7175C14.2537 33.7175 16.2102 31.761 16.2102 29.3475C16.2102 26.9341 14.2537 24.9775 11.8402 24.9775C9.42673 24.9775 7.47021 26.9341 7.47021 29.3475C7.47021 31.761 9.42673 33.7175 11.8402 33.7175Z"
        fill={fill}
      />
      <path
        d="M0.820001 21.6777C0.360001 21.6777 0 22.0477 0 22.4977V27.3077C0 28.0977 0.64 28.7277 1.42 28.7277H6.3C6.6 25.9377 8.97 23.7677 11.84 23.7677C14.71 23.7677 17.07 25.9477 17.38 28.7277H25.39C25.69 25.9377 28.06 23.7677 30.93 23.7677C33.8 23.7677 36.16 25.9477 36.47 28.7277H39.79C40.58 28.7277 41.21 28.0877 41.21 27.3077V21.6777H0.820001Z"
        fill={fill}
      />
      <path
        d="M30.92 24.9775C28.51 24.9775 26.55 26.9375 26.55 29.3475C26.55 31.7575 28.51 33.7175 30.92 33.7175C33.33 33.7175 35.29 31.7575 35.29 29.3475C35.29 26.9375 33.33 24.9775 30.92 24.9775Z"
        fill={fill}
      />
    </svg>
  );
};

export default TrcukOneIcon;
